"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueTimeoutUnitEnum = void 0;
var QueueTimeoutUnitEnum;
(function (QueueTimeoutUnitEnum) {
    QueueTimeoutUnitEnum["Seconds"] = "SECOND";
    QueueTimeoutUnitEnum["Minutes"] = "MINUTE";
    QueueTimeoutUnitEnum["Hours"] = "HOUR";
    QueueTimeoutUnitEnum["Days"] = "DAY";
})(QueueTimeoutUnitEnum = exports.QueueTimeoutUnitEnum || (exports.QueueTimeoutUnitEnum = {}));
